/* WizardInstanceEditorComponent.js */

"use strict";
const Registrations = require("./Registrations");
const GameEditor = require("@gluenetworks/game_editor");

class WizardInstanceEditorComponent extends GameEditor {
    constructor(logger, di, editorLayout, editorState, userSession, tabComponent) {
        super(logger, di, editorState.editorState, editorLayout);
        editorState.editorState.editorId = editorState.id;
        this._tabComponent = tabComponent;
        this.userSession = userSession;
        this._editorLayout = editorLayout;

        this._initializingProm = null;

        this.setNamespaceGlobs([Registrations.WIZARD_INSTANCE_EDITOR + ".**"], true);
        //NOTE: you must register views and actions as "WizardInstanceEditor.Views.<something>" and "WizardInstanceEditor.Actions.<something>"

        this._registerWieListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerWieListeners() {}
    _unregisterWieListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterWieListeners();
        return Promise.resolve();
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START EDITOR METHODS */
    /*******************************************/
    resizeContainer() {}
    /*******************************************/
    /* END EDITOR METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get editorId() {
        return this.getEditorId();
    }
    getEditorId() {
        return this._editorId;
    }
    setTitle(name) {
        this._tabComponent.setTitle(name);
        return this;
    }
    markDirty() {
        this._tabComponent.setDirty(true);
        return this;
    }
    markClean() {
        this._tabComponent.setDirty(false);
        return this;
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = WizardInstanceEditorComponent;
module.exports.$inject = [
    "$teve.logger",
    "$teve.di",
    "editorLayout.editorLayoutMgr",
    "editorLayout.editorState",
    "$teve.userSession",
    "editorLayout.editor.tabComponent",
];
module.exports.$editorIcon = "wizard.wizardEditor";
module.exports.$editorIconType = "base-icon-gl";
